const ITEMS = [
  "OEM Fuse Tapping",
  "100% Concealed Wiring",
  "Dual 4K Hardwiring",
  "Mobile Service Perth Metro",
  "No Battery Drain Guarantee",
  "12-Month Workmanship Warranty",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display font-bold uppercase tracking-[0.2em] text-xl sm:text-2xl text-gray-600 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2 h-2 rotate-45 bg-sky-500/70 shrink-0" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="ticker-marquee" className="relative border-y border-white/10 bg-carbon/60 py-5 overflow-hidden">
    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
      <Row />
      <Row />
    </div>
    <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent pointer-events-none" />
    <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent pointer-events-none" />
  </div>
);

export default Marquee;
